import styled from 'styled-components';

export const Headline = styled.div`
  min-width: 50%;
  position: absolute;
  top: -27px;
  left: 0px;
  color: #fff;
  font-weight: 500;
  font-family: 'Exo 2', sans-serif;
  font-size: 16px;
  text-align: center;
  text-transform: uppercase;
  background: ${(props) => (props.active ? '#272727' : '#f22121')};
  padding: 8px;
  z-index: 1;

  span {
    margin-left: 10px;
  }

  @media screen and (min-width: ${(props) => props.theme.xsmall}) {
    min-width: 300px;
  }

  @media screen and (min-width: ${(props) => props.theme.medium}) {
    font-size: 20px;
    padding: 13px 0;
    min-width: 500px;
  }
`;

export const Wrapper = styled.div`
  position: relative;
  width: 100%;
  max-width: ${(props) => props.theme.grid.width};
  margin: ${(props) => props.margin || '58px auto 80px auto'};
  padding: 0 10px;

  @media screen and (min-width: ${(props) => props.theme.medium}) {
    padding: 0;
  }
`;

export const Container = styled.div`
  width: 100%;
  position: relative;
  box-sizing: border-box;
  background-color: #14171c;
  padding: 0px 20px 30px 20px;

  @media screen and (min-width: ${(props) => props.theme.medium}) {
    width: 85%;
    margin: 0 auto;
  }

  @media screen and (min-width: ${(props) => props.theme.large}) {
    width: 1000px;
  }
`;

export const Anchor = styled.span`
  position: absolute;
  top: -97px;
  @media screen and (min-width: 1220px) {
    top: -27px;
  }
`;
